import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ForgetPasswordForm from "@hedgefund/shared/src/ForgetPasswordForm";
import { forgetPassword } from "./action";
import { alertService } from "@hedgefund/shared/src/Alert";

export const ForgetPassword = () => {
  const dispatch = useDispatch();
  const forgetPasswordState = useSelector((state) => state.forgetPassword);

  const { loading } = forgetPasswordState;

  const onSuccessAlert = () => {
    alertService.success("Email was sent successfully!", { autoClose: true });
  };

  const handleForgetPassword = (data) => {
    dispatch(forgetPassword(data, onSuccessAlert));
  };

  const checkEmail = (data) => {
    handleForgetPassword(data);
  };

  return (
    <ForgetPasswordForm
      loading={loading}
      onSubmit={(data) => checkEmail(data)}
    />
  );
};

export default ForgetPassword;
